import React, { useEffect, useState } from "react";
import {
  FaCheckCircle,
  FaRegStar,
  FaStar,
  FaTimesCircle,
  FaUndoAlt,
} from "react-icons/fa";
import { useSelector } from "react-redux";
import PriceTooltip from "./ToolTip";
import ReactQuill from "react-quill";
import { formattedAmount } from "../../utils/helpers/Functions.helper";
import { Dropdown } from "primereact/dropdown";
import { toast } from "react-toastify";
import { PackageApi } from "../../App/api/setting";

// const ProductInfo = ({
//   productData,
//   totalRating,
//   variant,
//   selectedVariant,
//   setSelectedVariant,
//   selectedSize,
//   setSelectedSize,
//   selectedColor,
//   setSelectedColor,
//   variantId,
// }) => {
//   const {
//     stock,
//     sales_price,
//     mrp_price,
//     harvest_date,
//     package_type,
//     nutritionalFields,
//     dynamicFields,
//     quality_grade,
//     return_policy,
//     replacement_policy,
//     cancellation_policy,
//   } = productData;
//   console.log("productData:", productData);

//   // const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
//   const [packageData, setPackageData] = useState();
//   const [isInCart, setIsInCart] = useState(false);
//   // const { product_details } = selectedVariant ? selectedVariant : productData;
//   const getPackageData = async () => {
//     try {
//       const res = await PackageApi.master.getAllPackageMaster();
//       const packagingData =
//         res?.data?.data?.packagingMaster.length &&
//         res?.data?.data?.packagingMaster.map((o, i) => {
//           o.value = o._id;
//           o.label = o?.packaging_name;
//           return o;
//         });

//       // console.log("package data:",res?.data?.data?.packagingMaster);
//       setPackageData(packagingData);
//     } catch (err) {
//       //console.log(err);
//       toast.error(err?.message);
//     } finally {
//       // handleLoading(false);
//     }
//   };
//   console.log("package data:", packageData);
//   useEffect(() => {
//     getPackageData();
//   }, []);
//   // const [selectedSizeDetails, setSelectedSizeDetails] = useState(
//   //   product_details && product_details[0]
//   // );

//   // Update selected size details when product_details changes
//   // useEffect(() => {
//   //   setSelectedSizeDetails(product_details[0]);
//   // }, [product_details]);

//   // const {
//   //   stock,
//   //   sales_price,
//   //   mrp_price,
//   //   taxData,
//   //   product_height,
//   //   product_weight,
//   //   product_width,
//   //   product_depth,
//   // } = selectedSizeDetails || {};

//   // Set default size and sizeId
//   // useEffect(() => {
//   //   if (product_details.length >= 0) {
//   //     setSelectedSize(product_details?.[0]?.product_size);
//   //     setSizeId(product_details?.[0]?._id);
//   //   }
//   // }, [product_details]);

//   // Set default color if none is selected
//   useEffect(() => {
//     if (!selectedVariant && productData?.product_color?.length > 0) {
//       setSelectedColor(productData.product_color[0]);
//     } else if (selectedVariant?.product_color?.length > 0) {
//       setSelectedColor(selectedVariant.product_color[0]);
//     }
//   }, [productData, selectedVariant]);

//   // const handleSizeClick = (size, sizeDetails) => {
//   //   setSelectedSizeDetails(sizeDetails);
//   //   setSizeId(sizeDetails?._id);
//   //   setSelectedSize(size);
//   // };

//   const handleColorClick = (color) => {
//     setSelectedColor(color);
//   };

//   const costPrice = mrp_price?.$numberDecimal;
//   const salePrice = sales_price?.$numberDecimal;
//   // const grandTotal = parseFloat(taxData?.grandTotal?.$numberDecimal).toFixed(2);
//   const grandTotal = salePrice;
//   const discountAmount = costPrice - grandTotal;
//   const percentageOff = (discountAmount / costPrice) * 100;

//   return (
//     <div>
//       <h1 className="text-2xl font-semibold mb-2">
//         {selectedVariant
//           ? selectedVariant.name
//           : productData?.name || "Product Name"}
//       </h1>

//       {/* Ratings Section */}
//       <div className="flex justify-start items-center mb-4">
//         {[...Array(5)].map((_, index) =>
//           index < productData?.average_rating ? (
//             <FaStar key={index} className="text-orange-500 text-xs" />
//           ) : (
//             <FaRegStar key={index} className="text-orange-500 text-xs" />
//           )
//         )}
//         <span className="text-sm text-gray-500 ml-2">
//           {/* ({productData?.average_rating.toFixed(1)}) */}
//           <span className="ml-4">
//             +{totalRating.toLocaleString("en-US")} ratings
//           </span>
//         </span>
//       </div>

//       {/* Product Info */}
//       {/* <p className="text-sm text-gray-600 mb-4">
//         {productData?.sub_category?.name || "Sub Category"} | {brand} | Model:{" "}
//         {model} | S.No: {serial_number}
//       </p> */}

//       {/* Price and Discount */}
//       <div className="flex items-baseline mb-2">
//         {costPrice && (
//           <p className="text-lg font-semibold text-red-500 mr-3">
//             -{percentageOff.toFixed(0)}%
//           </p>
//         )}
//         <div className="relative">
//           {/* <span className="text-sm absolute top-0 left-0">₹</span> */}
//           <p className="text-3xl font-bold text-gray-900 ml-3">
//             {/* {new Intl.NumberFormat("en-IN", {
//               maximumFractionDigits: 2,
//             }).format(grandTotal)} */}
//             {formattedAmount(grandTotal)}
//           </p>
//         </div>
//         <PriceTooltip
//           mrp={costPrice}
//           discount={discountAmount}
//           specialPrice={grandTotal}
//         />
//       </div>

//       {/* crop info  */}
//       {harvest_date && (
//         <div className="flex">
//           {" "}
//           <div className="w-[15%]">Harvest Date:</div>
//           <div> {new Date(harvest_date).toLocaleDateString()}</div>
//         </div>
//       )}
//       {quality_grade && (
//         <div className="flex">
//           {" "}
//           <div className=" w-[15%]">Quality Grade:</div>
//           <div className="">
//             {quality_grade.replace(
//               /(\D*)(\d+)/,
//               (_, text, number) =>
//                 `${text.charAt(0).toUpperCase()}${text.slice(1)} ${number}`
//             )}
//           </div>
//         </div>
//       )}
//       {package_type && (
//         <div className="flex">
//           {" "}
//           <div className=" w-[15%]">Package Type:</div>
//           <div className="">
//             {packageData?.find(
//               (item) => item.value === productData.package_type
//             )?.packaging_name || "N/A"}
//           </div>
//         </div>
//       )}

//       {/* Stock and Sizes */}
//       {(selectedVariant?.stock ?? stock) < 10 &&
//         (selectedVariant?.stock ?? stock) !== 0 && (
//           <p className="text-[#ff6161] text-sm">
//             Hurry, Only {selectedVariant?.stock ?? stock} left!
//           </p>
//         )}
//       <p
//         className={`text-sm font-semibold mb-3 ${
//           stock > 0 ? "text-green-500" : "text-red-500"
//         }`}
//       >
//         {stock > 0 ? "In Stock" : "Out of Stock"}
//       </p>

//       {/* Nutritional Fields */}
//       {dynamicFields && (
//         <div>
//           <h2 className="text-xl font-bold text-gray-900 mb-2">
//             Nutritional Contains
//           </h2>
//           {Object.entries(dynamicFields).map(([key, value]) => (
//             <div key={key} className="flex">
//               <h3 className="w-[15%] capitalize">{key.replace(/_/g, " ")}: </h3>
//               <p>{value}</p>
//             </div>
//           ))}
//         </div>
//       )}
//       {nutritionalFields && (
//         <div className="mb-4">
//           {Object.entries(nutritionalFields).map(([key, value]) => (
//             <div key={key} className="flex">
//               <h3 className="w-[15%] capitalize">{key.replace(/_/g, " ")}: </h3>
//               <p>{value}</p>
//             </div>
//           ))}
//         </div>
//       )}

//       {/* Policies Section */}
//       <div className="mb-0">
//         <h2 className="text-xl font-bold text-gray-900 mb-2">Policies</h2>
//         <PolicyItem
//           icon={<FaUndoAlt className="text-yellow-500 mr-2" />}
//           label="Return Policy:"
//           policy={return_policy}
//         />
//         <PolicyItem
//           icon={<FaCheckCircle className="text-green-500 mr-2" />}
//           label="Replacement Policy:"
//           policy={replacement_policy}
//         />
//         <PolicyItem
//           icon={<FaTimesCircle className="text-red-500 mr-2" />}
//           label="Cancellation Policy:"
//           policy={cancellation_policy}
//         />
//       </div>

//       {/* Product Dimensions Section */}
//       {/* <div className="mt-6">
//         <h2 className="text-xl font-bold text-gray-900 mb-2">Product Dimensions</h2>
//         <ProductDimensions
//           height={product_height}
//           width={product_width}
//           depth={product_depth}
//           weight={product_weight}
//         />
//       </div> */}
//     </div>
//   );
// };

// export default ProductInfo;



// // Policy Display Component
// const PolicyItem = ({ icon, label, policy }) => (
//   <div className="text-sm text-gray-700 mb-3 flex  items-start">
//     <span className="font-semibold flex justify-center items-center mt-2">
//       {" "}
//       {icon} {label}
//     </span>
//     <span
//       className="font-semibold flex justify-center items-center mt-2"
//       dangerouslySetInnerHTML={{
//         __html: policy || "<p>Not available.</p>",
//       }}
//     />

//     {/* {policy?(<ReactQuill
//       value={policy}
//       readOnly={true}
//       theme={"bubble"}
//     />):( <span className="ml-2">Not available</span>)} */}
//   </div>
// );


const ProductInfo = ({
  productData,
  totalRating,
  theme,
  selectedVariant,
  setSelectedColor,
}) => {
  const {
    stock,
    sales_price,
    mrp_price,
    harvest_date,
    package_type,
    nutritionalFields,
    dynamicFields,
    quality_grade,
    return_policy,
    replacement_policy,
    cancellation_policy,
  } = productData;


  const [packageData, setPackageData] = useState();
  const { product_details } = selectedVariant ? selectedVariant : productData;
  const [selectedSizeDetails, setSelectedSizeDetails] = useState(
    product_details && product_details[0]
  );
  console.log("productData:", productData);

  // Update selected size details when product_details changes
  // useEffect(() => {
  //   setSelectedSizeDetails(product_details[0]);
  // }, [product_details]);

  // const { stock, sales_price, mrp_price, taxData } = selectedSizeDetails || {};

  // Set default size and sizeId
  // useEffect(() => {
  //   if (product_details.length >= 0) {
  //     setSelectedSize(product_details?.[0]?.product_size);
  //     setSizeId(product_details?.[0]?._id);
  //   }
  // }, [product_details]);

  // Set default color if none is selected
  useEffect(() => {
    if (!selectedVariant && productData?.product_color?.length > 0) {
      setSelectedColor(productData.product_color[0]);
    } else if (selectedVariant?.product_color?.length > 0) {
      setSelectedColor(selectedVariant.product_color[0]);
    }
  }, [productData, selectedVariant]);

  const getPackageData = async () => {
    try {
      const res = await PackageApi.master.getAllPackageMaster();
      const packagingData =
        res.data?.data.length &&
        res.data?.data.map((o, i) => {
          o.value = o._id;
          o.label = o?.packaging_name;
          return o;
        });

        console.log("package data:",res?.data?.data?.packagingMaster);
      setPackageData(packagingData);
    } catch (err) {
      //console.log(err);
      toast.error(err?.message);
    } finally {
      // handleLoading(false);
    }
  };
  
  useEffect(() => {
    getPackageData();
  },[]);
  const costPrice =
    mrp_price?.$numberDecimal ;
  const salePrice =
    sales_price?.$numberDecimal;
  const grandTotal = salePrice;
    // parseFloat(taxData?.grandTotal?.$numberDecimal).toFixed(2) || 0.0;
  const discountAmount = costPrice - grandTotal;
  const percentageOff = (discountAmount / costPrice) * 100;

  return (
    <div>
      <h1 className={`text-2xl font-semibold mb-2 ${theme? "text-gray-900":"text-gray-200"}`}>
        {selectedVariant
          ? selectedVariant.name
          : productData?.name || "Product Name"}
      </h1>

      {/* Ratings Section */}
      <div className="flex justify-start items-center mb-4">
        {[...Array(5)].map((_, index) =>
          index < productData?.average_rating ? (
            <FaStar key={index} className="text-orange-500 text-xs" />
          ) : (
            <FaRegStar key={index} className="text-orange-500 text-xs" />
          )
        )}
        {/* <span className="text-sm text-gray-500 ml-2">
          ({productData?.average_rating.toFixed(1)})
          <span className="ml-4">+{totalRating.toLocaleString("en-US")} ratings</span>
        </span> */}
      </div>

      {/* Product Info */}
      <p className={`text-sm  mb-4 ${theme? "text-gray-900":"text-gray-200"}`}>
        {productData?.sub_category?.name || "Sub Category"}
        {/* | {brand} | Model:{" "} */}
        {/* {model} | S.No: {serial_number} */}
      </p>

      {/* Price and Discount */}
      <div className= {`flex items-baseline mb-2 ${theme? "text-gray-900":"text-gray-200"}`}>
        <span className={`line-through text-base ${theme? "text-gray-900":"text-gray-200"}`}>
          {formattedAmount(costPrice)}
        </span>
        <div className="relative">
          {/* <span className="text-sm absolute top-0 left-0">₹</span> */}
          <p className={`text-3xl font-bold ${theme? "text-gray-900":"text-gray-200"} ml-3`}>
            {/* {new Intl.NumberFormat("en-IN", {
              maximumFractionDigits: 2,
            }).format(grandTotal)} */}
            {formattedAmount(salePrice)}
          </p>
        </div>
        <PriceTooltip
          mrp={costPrice}
          discount={discountAmount}
          specialPrice={grandTotal}
        />
      </div>
      {/* crop info  */}
      {harvest_date && (
        <div className="flex">
          {" "}
          <div className={`w-[25%] ${theme? "text-gray-900":"text-gray-200"}`}>Harvest Date:</div>
          <div className={`${theme? "text-gray-900":"text-gray-200"}`}> {new Date(harvest_date).toLocaleDateString()}</div>
        </div>
      )}
      {quality_grade && (
        <div className="flex">
          {" "}
          <div className={`w-[25%] ${theme? "text-gray-900":"text-gray-200"}`}>Quality Grade:</div>
          <div className={`${theme? "text-gray-900":"text-gray-200"}`}>
            {quality_grade.replace(
              /(\D*)(\d+)/,
              (_, text, number) =>
                `${text.charAt(0).toUpperCase()}${text.slice(1)} ${number}`
            )}
          </div>
        </div>
      )}
      {package_type && (
        <div className="flex">
          {" "}
          <div className={`w-[25%] ${theme? "text-gray-900":"text-gray-200"}`}>Package Type:</div>
          <div className={`${theme? "text-gray-900":"text-gray-200"}`}>
            {packageData?.find(
              (item) => item.value === productData.package_type
            )?.packaging_name || "N/A"}
          </div>
        </div>
      )}

      {/* Stock and Sizes */}
      {(stock ? stock : productData?.stock) < 10 &&
        (stock ? stock : productData?.stock) !== 0 && (
          <p className="text-[#ff6161] text-sm">
            Hurry, Only {stock ? stock : productData?.stock} left!
          </p>
        )}
      <p
        className={`text-sm font-semibold mb-3 ${stock> 0
            ? "text-green-500"
            : "text-red-500"
        }`}
      >
        {stock > 0 ? "In Stock" : "Out of Stock"}
      </p>

      {/* Nutritional Fields */}
      {dynamicFields && (
        <div>
          <h2 className={`text-xl font-bold mb-2 ${theme? "text-gray-900":"text-gray-200"}`}>
            Nutritional Contains
          </h2>
          {Object.entries(dynamicFields).map(([key, value]) => (
            <div key={key} className={`flex ${theme? "text-gray-900":"text-gray-200"}`}>
              <h3 className="w-[25%] capitalize font-medium">{key.replace(/_/g, " ")}: </h3>
              <p>{value}</p>
            </div>
          ))}
        </div>
      )}
      {nutritionalFields && (
        <div className="mb-4">
          {Object.entries(nutritionalFields).map(([key, value]) => (
            <div key={key} className={`flex ${theme? "text-gray-900":"text-gray-200"}`}>
              <h3 className="w-[25%] capitalize font-medium">{key.replace(/_/g, " ")}: </h3>
              <p>{value}</p>
            </div>
          ))}
        </div>
      )}

      {/* Policies Section */}
      <div className="mb-0">
        <h2 className={`text-xl font-bold  mb-2 ${theme? "text-gray-900":"text-gray-200"}`}>Policies</h2>
        <PolicyItem
          icon={<FaUndoAlt className="text-yellow-500 mr-2" />}
          label="Return Policy:"
          policy={return_policy}
          theme={theme}
        />
        <PolicyItem
          icon={<FaCheckCircle className="text-green-500 mr-2" />}
          label="Replacement Policy:"
          policy={replacement_policy}
          theme={theme}
        />
        <PolicyItem
          icon={<FaTimesCircle className="text-red-500 mr-2" />}
          label="Cancellation Policy:"
          policy={cancellation_policy}
          theme={theme}
        />
      </div>

      {/* Product Dimensions Section */}
      {/* <div className="mt-6">
        <h2 className="text-xl font-bold text-gray-900 mb-2">Product Dimensions</h2>
        <ProductDimensions
          height={product_height}
          width={product_width}
          depth={product_depth}
          weight={product_weight}
        />
      </div> */}
    </div>
  );
};

export default ProductInfo;


// Policy Display Component
const PolicyItem = ({ icon, label, policy, theme }) => (
  <div className="text-sm  mb-3 flex  items-start">
    <span className={`font-semibold flex justify-center items-center mt-2 ${theme? "text-gray-900":"text-gray-200"}`}>
      {" "}
      {icon} {label}
    </span>
    <span
      className={`font-medium flex justify-center items-center mt-2 ${theme? "text-gray-900":"text-gray-200"}`}
      dangerouslySetInnerHTML={{
        __html: policy || "<p>Not available.</p>",
      }}
    />

    {/* {policy?(<ReactQuill
      value={policy}
      readOnly={true}
      theme={"bubble"}
    />):( <span className="ml-2">Not available</span>)} */}
  </div>
);